<section class="reset-pwd-page verifyIdentityWrapper">
  <div class="reset-pwd-wrapper">
    <div class="reset-pwd card">
      <div class="section1">
        <div class="logoImgBox">
          <img src="../../../assets/new-dash/logo/revenuedLogo_black.png" class="logoImg" alt="Revenued Logo" />
        </div>
        <div class="formBox">
          <h1 class="welcomeTitle">
            Verify Your Identity
          </h1>
          <p class="welcomePara">
            Please choose a method to receive your verification code.
          </p>

          <form class="form-container-wrapper">
            <div class="form-container">
              <mat-radio-group class="radio-group" [(ngModel)]="selectedMethod" name="method">
                <div class="custom-radio-wrapper" [ngClass]="{'selectedMethod': this.selectedMethod === 'email'}">
                  <mat-radio-button class="custom-radio" value="email" (change)="selectedMethod = 'email'">
                    <div class="option-container">
                      <div class="icon-container">
                        <mat-icon>mail</mat-icon>
                      </div>
                      <div class="text-container">
                        <div class="title">Email <span class="masked-value">{{maskedEmail}}</span></div>
                        <div class="subtitle">Receive a code via email</div>
                      </div>
                    </div>
                  </mat-radio-button>
                </div>

                <div class="custom-radio-wrapper" *ngIf="disabledSmsMfaOption === 'false' && !isSmsHidden" [ngClass]="{'selectedMethod': this.selectedMethod === 'sms'}">
                  <mat-radio-button class="custom-radio" value="sms"
                    (change)="selectedMethod = 'sms'">
                    <div class="option-container">
                      <div class="icon-container">
                        <mat-icon>chat</mat-icon>
                      </div>
                      <div class="text-container">
                        <div class="title">SMS <span class="masked-value">{{maskedPhone}}</span></div>
                        <div class="subtitle">Receive a code via text message</div>
                      </div>
                    </div>
                  </mat-radio-button>
                  <hr class="primaryDivider" />
                  <mat-checkbox class=" optinCheckbox mt-1" [checked]="isOptInChecked && this.selectedMethod === 'sms'"
                    required [disabled]="this.selectedMethod != 'sms'" (change)="toggleOptInCheckbox()"
                    [@accordionAnimation]>
                    By checking this box, I agree to receive SMS messages from Revenued for login verification. Message
                    & data rates may apply. Reply STOP to unsubscribe. View our
                    <a href="https://www.revenued.com/terms" target="_blank" class="link">Terms of
                      Service</a>
                    and <a href="https://www.revenued.com/privacy-policy" target="_blank" class="link">Privacy Policy
                    </a>.
                  </mat-checkbox>
                </div>
              </mat-radio-group>

              <mat-error *ngIf="!this.selectedMethod" [@accordionAnimation] class="mt-3">
                Please select a method
              </mat-error>


              <!-- <hr class="primaryDivider" *ngIf="this.selectedMethod === 'sms'" [@accordionAnimation] /> -->
              <div class="section-dropWrapper">
                <div class="section-drop d-flex justify-content-between align-items-center">
                  <mat-checkbox [disabled]="!this.selectedMethod" class="preferredModeCheckbox"
                    [(ngModel)]="preferredMethod" name="preferredMethod"
                    (change)="onPreferredMethodChange($event.checked)" [disabled]="!selectedMethod">
                    Set this as preferred mode
                  </mat-checkbox>
                  <!-- <button mat-icon-button (click)="togglePreferredInfoAccordion()" class="arrow-button">
                    <mat-icon>
                      {{isPreferredInfoExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                    </mat-icon>
                  </button> -->
                </div>
                <div class="accordion-content mt-1" [@accordionAnimation]>
                  <p [ngClass]="{'disabledText': !this.selectedMethod}">
                    By selecting this option, we'll remember your choice for future logins.
                    This means you won't need to select between email and SMS each time you verify your identity.
                  </p>
                </div>
              </div>
            </div>


            <div class="termsLinkWrapper d-none mt-2 mb-2 text-center text-xs text-gray-500">By clicking "Verify", you
              confirm
              that you have
              read and agree to our <a href="https://www.revenued.com/terms" target="_blank"
                class="text-green-500 hover:underline">Terms of Service</a> and <a
                href="https://www.revenued.com/privacy-policy" target="_blank"
                class="text-green-500 hover:underline">Privacy Policy
              </a>
            </div>

            <!-- Error Message Display -->
            <!-- <mat-error *ngIf="errorMessage" class="mainError mt-2 mb-3">{{ errorMessage }}</mat-error> -->


            <div>
              <button class="primary-general-btn w-100" matRipple (click)="verifyIdentity()"
                [disabled]="!selectedMethod || (selectedMethod === 'sms' && !isOptInChecked)">
                <div *ngIf="verify; else generalCondition">
                  <app-loader></app-loader>
                </div>
                <ng-template #generalCondition>
                  <span>Verify</span>
                </ng-template>
              </button>


            </div>
          </form>


          <div class="bottom-action-links mt-4 mb-0">
            <!-- <a href="javascript:void(0);" (click)="tryOtherMethods()" class="link-items">
              Try Another Method
            </a> -->
            <a href="javascript:void(0);" routerLink="/login" class="link-items">

              Back To Sign-In
            </a>
          </div>
        </div>
      </div>
      <div class="section2">
        <div class="inner-div">
          <!-- <p class="content">
            A card that cares less about FICO and more about your business
          </p> -->
          <figure class="m-0">
            <img src="../../../assets/new-dash/login/createPwd.webp" alt="Verify MFA" />
          </figure>
        </div>
      </div>
    </div>
    <footer class="footer-verifyIdentity">
      <div class="footerMenu">
        <a href="https://www.revenued.com/about/" class="footerMenuLink" target="_blank">
          About Revenued
        </a>
        <a href="https://www.revenued.com/contact/" class="footerMenuLink" target="_blank">
          Contact Us
        </a>
        <a href="https://www.revenued.com/revenued-cardholder-agreement/" class="footerMenuLink" target="_blank">
          Card User Agreement
        </a>
        <a href="https://www.revenued.com/terms" target="_blank" class="footerMenuLink">
          Terms of Service
        </a>
        <a href="https://www.revenued.com/privacy-policy" target="_blank" class="footerMenuLink">
          Privacy Policy
        </a>
      </div>
    </footer>
  </div>
  <!-- <div class="bgImage"></div> -->
</section>